<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <div class="flex column">
      <el-row>
        <el-col :span="24">
          <rabbey-table2
            ref="rTable"
            :columns="columns"
            :actions="actions"
            @rtable-push-action="handlePushAction"
          />
        </el-col>
      </el-row>
    </div>

    <el-drawer
      :title="title"
      size="30%"
      :with-header="true"
      :visible.sync="drawer"
      @closed="handleClosed"
    >
      <el-container direction="vertical">
        <el-main>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form
                ref="el_form"
                :model="model"
                label-position="left"
                size="mini"
                label-width="120px"
              >
                <el-form-item label="Nombre" prop="DisplayName">
                  <el-input
                    v-model="model.DisplayName"
                    :disabled="isView"
                    autofocus
                  ></el-input>
                </el-form-item>

                <el-form-item label="" label-width="0">
                  <el-button
                    v-if="!isView"
                    type="primary"
                    v-loading="loading"
                    @click="onSubmit"
                    >{{ button_submit_text }}</el-button
                  >
                  <el-button @click="drawer = false">Cancel</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </vue-scroll>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import RenderCheck from "@/components/functionals/RenderCheck";

export default {
  name: "ActivityConditions",
  data() {
    return {
      alejandro: "ale",
      isEdit: false,
      isView: false,
      drawer: false,
      title: "Crear",
      columns: [
        {
          prop: "DisplayName",
          name: "Nombre",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "Phase.Name",
          name: "Fase",
          formatter: (row) => {
            return row.Phase.Name;
          }
        },
        {
          prop: "CreatedByUser.FullName",
          name: "Creador",
          formatter: (row) => {
            return row.CreatedByUser.FullName;
          }
        },
        {
          prop: "IsEnabled",
          name: "Habilitado",
          formatter: RenderCheck
        },
        {
          prop: "Min",
          name: "Minimo"
        },
        {
          prop: "Max",
          name: "Maximo"
        },
        {
          prop: "Required",
          name: "Requerido",
          formatter: RenderCheck
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],
      button_submit_text: "Crear",
      loading: false,
      model: {
        DisplayName: null
      }
    };
  },
  created() {
    this.$store.dispatch("rabbey_table/getItems", {
      url: "/api/ActivityConditions"
    });
  },
  methods: {
    ...mapMutations({
      removeItem: "rabbey_table/removeItem",
      pushItem: "rabbey_table/pushItem",
      updateItem: "rabbey_table/updateItem"
    }),
    handlePushAction(command) {
      Object.assign(this.model, command.row);
      switch (command.command) {
        case "view":
          this.isView = true;
          this.drawer = true;
          break;

        case "edit":
          this.isEdit = true;
          this.isView = false;
          this.button_submit_text = "Actualizar";
          this.drawer = true;
          break;

        case "delete":
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.$http
                .post(
                  "/api/currency/Disable",
                  {},
                  {
                    params: {
                      "criteria.Id": this.model.Id
                    }
                  }
                )
                .then(() => {
                  const index = this.list.findIndex(
                    (item) => item.Id === this.model.Id
                  );
                  this.removeItem(index);
                  this.$message.success("Tipo de oportunidad eliminada");
                })
                .catch(() => {
                  this.$message.error("Error al eliminar tipo de oportunidad");
                });
            })
            .catch(() => {});
          break;

        default:
          break;
      }
    },
    callNew() {
      this.button_submit_text = "Crear";
      this.isView = false;
      this.isEdit = false;
      this.drawer = true;
    },
    onSubmit() {
      this.$refs.el_form.validate((valid) => {
        if (valid) {
          this.loading = true;

          if (this.isEdit) {
            this.$http
              .put("/api/currency/Update", this.model)
              .then((resp) => {
                this.updateItem({ Id: this.model.Id, item: resp.data });
                this.drawer = false;
                this.$message.success("Fase actualizada");
              })
              .catch(() => {
                this.$message.error("Error al actualizar la fase");
              })
              .finally(() => (this.loading = false));
          } else {
            this.$http
              .post("/api/currency/Add", this.model)
              .then((resp) => {
                this.pushItem(resp.data);
                this.drawer = false;
                this.$message.success("Fase creada");
              })
              .catch(() => {
                this.$message.error("Error al crear la fase");
              })
              .finally(() => (this.loading = false));
          }
        } else {
          return false;
        }
      });
    },
    handleClosed() {
      this.$refs.el_form.resetFields();
    }
  },
  computed: mapState({ list: (state) => state.rabbey_table.items })
};
</script>

<style></style>
